import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-default-money',
  templateUrl: './money.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoneyComponent {
  @Input() customClass = '';
  @Input() data: any;
  @Input() currencyCode: string;
  public transformPositive = (value: string): string => Math.abs(Number(value)).toFixed(2);
}
